import React from 'react'

interface LineProgressBarProps {
  percentage: number
  stroke: string
  strokeWidth: number
}

const LineProgressBar: React.FC<LineProgressBarProps> = ({
  percentage,
  stroke,
  strokeWidth,
}) => {
  return (
    <div className="w-full">
      <div className="flex gap-3 items-center">
        <div
          style={{
            height: `${strokeWidth * 4}px`,
          }}
          className={`w-full rounded-full bg-gray3`}
        >
          <div
            className={`rounded-full`}
            style={{
              width: `${percentage}%`,
              backgroundColor: stroke,
              height: `${strokeWidth * 4}px`,
            }}
          ></div>
        </div>
        <p className="text-xs font-semibold leading-5 text-bluishGreen">{`${percentage}%`}</p>
      </div>
    </div>
  )
}

export default LineProgressBar
